export default {
  data () {
    return {
      total: 0,
      results: [],
      loading: false
    }
  },
  methods: {
    async doSearch (filterVals = {}, successCallback = () => {}, errorCallback = () => {}) {
      this.loading = true
      const { status, payload } = await this.$post('v1/appointments/search', {
        page: filterVals.page || 1,
        rows: filterVals.rows || 10,
        sortBy: filterVals.sortBy || 'closest',
        sortDirection: filterVals.sortDirection || 'asc',
        filter: filterVals.filter || null,
        start: filterVals.start || null,
        end: filterVals.end || null,
        all_day: filterVals.allDay || false,
        status: filterVals.status || null,
        users: filterVals.users || [],
        clients: filterVals.clients || [],
        appointment_types: filterVals.appointmentTypes || [],
        color: filterVals.color || null,
        timezone: filterVals.timezone || null,
        is_scheduled: filterVals.isScheduled || false,
        creator: filterVals.creator || null
      })
      this.loading = false
      if (status === 'success') {
        this.results = payload.appointments
        this.total = payload.total
        successCallback()
      }
      else {
        errorCallback()
      }
    }
  }
}
